<div class="sidenav-content copo-admin-sidenav-content">
	<div class="copo-admin-flex-box">
		<div class="copo-admin-title-block">
			<div class="copo-admin-title-label">Administration Overview</div>
		</div>
		<div class="copo-admin-grid-container">
			<div class="margin-pend">
				<h2>Users to validate</h2>
			</div>
			<span *ngIf="pendUserData && pendUserData.length > 0">
				<div *ngFor="let user of pendUserData">
					<table class="pend-table">
						<tr>
							<td class="first-row">
								<b>{{ user.fullName }}</b>
							</td>
						</tr>
						<tr>
							<td><small>Organization</small></td>
							<td><small>Level of rights</small></td>
							<td></td>
							<td></td>
						</tr>
						<tr>
							<td>{{ user.orgName }}</td>
							<td>{{ user.role }}</td>
							<td>
								<button mat-mini-fab color="white" type="button">
									<mat-icon class="dashboard-admin-icon" svgIcon="close"
										(click)="rejectUser(user.userId,user.orgId)"></mat-icon>
								</button>
							</td>
							<td>
								<button mat-mini-fab color="white" type="button">
									<mat-icon class="dashboard-tick-icon" svgIcon="md:done"
										(click)="updateUserRole(user.userId,user.orgId)"></mat-icon>
								</button>
							</td>
						</tr>
					</table>
				</div>
			</span>
		</div>
	</div>
</div>